"use strict";

define(['app'], function (app) {
  return app.Marionette.ItemView.extend({
    template: false,
    events: {
      click: 'show'
    },
    show: function show(e) {
      e.preventDefault();
      var el = app.$(e.currentTarget);
      var modal = el.data('modal');
      app.events.commands.execute('modal:' + modal + ':show');
      return false;
    }
  });
});